import type { ApiIntakeIntents } from 'api/types/ApiIntakeIntents';
import type { ApiISODateTimeString } from 'api/types/ApiTypedDate';
import { postJson } from 'utils/http/postJson';

export type SaveUserDashboardIntakeIntentsResponse = {
  intakeIntents: ApiIntakeIntents[];
  intakeIntentsDatetimeSet: ApiISODateTimeString;
};

type Args = {
  intakeIntents: ApiIntakeIntents[];
};

export function userDashboardApiSavePostingIntention({
  intakeIntents,
}: Args): Promise<SaveUserDashboardIntakeIntentsResponse> {
  return postJson<SaveUserDashboardIntakeIntentsResponse>(
    '/data/userdashboard/intake-intents',
    {
      intakeIntents,
    },
  );
}
